var $c288097c5ef4ae98$exports = {};
$c288097c5ef4ae98$exports = {
    "dismiss": `Kapat`
};


export {$c288097c5ef4ae98$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
